import React from 'react';
import PropTypes from 'prop-types';
import Input from '@tds/core-input';

import { Box } from '../design/css';

const OrderIdFilter = ({ label, placeholder, updateFilters, value }) => {
  return (
    <Box width={30} mdWidth={100} pb={24}>
      <Input
        label={label}
        placeholder={placeholder}
        onChange={e => updateFilters('orderId', e.target.value)}
        value={value}
      />
    </Box>
  );
};

OrderIdFilter.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  updateFilters: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export default OrderIdFilter;
